import { render, staticRenderFns } from "./DeliveryInformation.vue?vue&type=template&id=c93f86b4&scoped=true"
import script from "./DeliveryInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliveryInformation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DeliveryInformation.vue?vue&type=style&index=0&id=c93f86b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93f86b4",
  null
  
)

export default component.exports